import { Modal } from "react-bootstrap";
import { Link } from "@mui/material";

const LetsConnect = ({ show, hide }) => {
	return (
		<Modal
			id="form-modal-open"
			size="lg"
			show={show}
			onHide={hide}
			className="lets-connect-modal  lets-connect-newmodal"
		>
			<Modal.Header closeButton>
				{/* <h4>Get in touch with us</h4> */}
			</Modal.Header>

			<Modal.Body>
				<div className="row gy-4">
					<div className="col-lg-6 col-md-6">
						<div className="card card-blue">
							<div className="card-img">
								<h2>CLIENT</h2>
							</div>
							<div className="card-body">
								<h4 className="card-title">
									Are you a client looking to hire dedicated
									developers on contract basis?
								</h4>
								<Link
									href="/hire-dedicated-developers"
									className={`btn btn-secondary`}
								>
									<span>Click Here</span>
								</Link>
							</div>
						</div>
					</div>
					<div className="col-lg-6 col-md-6">
						<div className="card card-green">
							<div className="card-img">
								<h2>DEVELOPER</h2>
							</div>
							<div className="card-body">
								<h4 className="card-title">
									Are you a developer looking for job?
								</h4>
								<Link
									href="/careers"
									className={`btn btn-secondary`}
								>
									<span>Click Here</span>
								</Link>
							</div>
						</div>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default LetsConnect;
